import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  DateRangePickerModalMessage,
  DateRangePickerModalState,
} from '../../interfaces/connected-components/dateRangePicker';

const initialState: DateRangePickerModalState = {
  isVisible: false,
};

export const dateRangePickerModalSlice = createSlice({
  name: 'dateRangePickerModal',
  initialState,
  reducers: {
    showDateRangePickerModal: (
      state,
      action: PayloadAction<DateRangePickerModalMessage>,
    ) => {
      state.isVisible = true;
      state.onConfirm = action.payload.onConfirm;
      state.currentRange = action.payload.currentRange;
      state.mode = action.payload.mode;
      // @ts-ignore
      state.datePickerProps = action.payload.datePickerProps;
    },
    hideDateRangePickerModal: state => {
      state.isVisible = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {showDateRangePickerModal, hideDateRangePickerModal} =
  dateRangePickerModalSlice.actions;

export default dateRangePickerModalSlice.reducer;
